






















































import { JournalEntry } from "../models/JournalEntry";

export default {
    name: "JournalEntryCommunicationTypeIcon",
    props: {
        journalEntry: Object,
    },
    data() {
        return {
            ECommunicationType: JournalEntry.ECommunicationType,
        };
    },
};
